import { request } from '@/utils/ajax';
import { OptionalId, ExtraCost } from '@/types';

// export function getExtraCosts(residentialUnitId: number): Promise<ExtraCost[]> {
//     return request(`api/extra-cost`, { query: { residentialUnitId } }).then((x) => x.json());
// }

// export function saveExtraCost(item: OptionalId<ExtraCost>): Promise<ExtraCost> {
//     return request(`api/extra-cost`, {
//         method: 'POST',
//         json: true,
//         body: item,
//     }).then((x) => x.json());
// }

export function getExtraCosts(residentialUnitId: number): Promise<ExtraCost[]> {
    return request(`api/residential-unit/${residentialUnitId}/extra-costs`).then((x) => x.json());
}

export function saveExtraCost(residentialUnitId: number, item: OptionalId<ExtraCost>[]): Promise<ExtraCost> {
    return request(`api/residential-unit/${residentialUnitId}/extra-costs`, {
        method: 'PUT',
        json: true,
        body: item,
    }).then((x) => x.json());
}